import 'bootstrap/dist/css/bootstrap.css';
import 'leaflet/dist/leaflet.css';
import './styles/tokens.css';
import './styles/sfa.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { installApiBaseUrlSupport } from './apiBase';
import { installAuthInterceptor } from './authInterceptor';
import { installCrossTabSessionWatcher } from './utils/session';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

installApiBaseUrlSupport();
// apiBase'ten SONRA: onun rewrite'lı fetch'ini de sarsın. 401 → login yönlendirmesi.
installAuthInterceptor();
// Başka bir sekmedeki çıkışı (localStorage paylaşımlı olduğu için bu sekmeyi de düşürür)
// sebebiyle birlikte yakalar; aksi halde bu sekme sessizce 401'e düşerdi.
installCrossTabSessionWatcher();

let serviceWorkerRefreshing = false;
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (serviceWorkerRefreshing) return;
    serviceWorkerRefreshing = true;
    window.location.reload();
  });
}

root.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>);

// Service worker KAPATILDI (unregister). Gerekçe: bu back-office admin panelinde hiçbir uygulama
// kodu SW'ye/offline'a bağımlı değil (SW yalnız app-shell'i cache'liyordu). Bu cache, her deploy
// sonrası tarayıcıya ESKİ sürümü servis edip düzeltilen maddelerin tekrar "yapılmamış/NOK" gibi
// görünmesine yol açıyordu (713/717/731/734/737 kök nedeni). unregister ile mevcut cache temizlenir
// ve bundan sonra her deploy ANINDA canlı olur. Offline/PWA istenirse register'a geri dönülebilir.
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
